import React from 'react';
import { CheckCircle2 } from 'lucide-react';

const WhyTraainDefense = () => {
  const capabilities = [
    'Master complex communication protocols',
    'Strengthen coordination across units and agencies',
    'De-escalate high-pressure situations',
    'Maintain compliance in real time',
    'Improve decision-making under pressure',
    'Reduce errors and misunderstandings'
  ];

  return (
    <section className="py-24 px-6 bg-gradient-to-b from-transparent to-cyan-950/20">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-4 text-white">
            One Platform. One Standard. <span className="text-cyan-400">Every Operation.</span>
          </h2>
          <p className="text-xl text-gray-300 max-w-4xl mx-auto">
            Traain equips defense organizations and their contractors to prepare personnel for critical conversations, decision-making, and compliance scenarios.
          </p>
        </div>

        <div className="max-w-3xl mx-auto mb-12">
          <p className="text-xl font-bold text-white mb-6 text-center">With Traain, defense teams:</p>
          <div className="grid md:grid-cols-2 gap-4">
            {capabilities.map((capability, index) => (
              <div
                key={index}
                className="flex items-start gap-4 p-5 rounded-xl bg-gradient-to-br from-gray-900/80 to-cyan-900/20 border border-cyan-500/30 hover:border-cyan-400/60 transition-all duration-300"
              >
                <CheckCircle2 className="w-6 h-6 text-cyan-400 flex-shrink-0 mt-1" />
                <p className="text-gray-300">{capability}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyTraainDefense;
